import { CircularProgress, Grid, Typography } from '@mui/material';

import {
  BucketAwtENUM,
  EstadosImagenChoiceEnum,
  extractIdsFromObjRes,
  gridSizeMdLg12,
  gridSizeMdLg6,
  // updateDocumentByIdDriveNewComponent,
  // useUpdatePhotosGeneric,
  useUploadFile,
} from '@/shared';
import {
  OrdenTrabajoQueryKeysEnum,
  UploadSalidaImagesOTData,
  useUpdateOrdenTrabajo,
} from '@/shared/actions/erp';
import { CustomPaperBox, SingleIconButton, TabTextLabel } from '@/shared/components/ui';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import {
  AlertSeverityEnum,
  ApiFileRespAWT,
  // FotoType,
  OrdenTrabajo,
  PhotosSalidaOTType,
  // PaymentMethodEnum,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { useUploadImageComponent } from '../../../hooks/useUploadImageComponent';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { ReplayOutlined } from '@mui/icons-material';
import { useUploadImageStore } from '@/store/erp';

export type ActualizarFotosSalidaTecOTModalProps = {
  ordenTrabajo: OrdenTrabajo;
  open: boolean;
  onClose: () => void;
};

const ActualizarFotosSalidaTecOTModal: React.FC<
  ActualizarFotosSalidaTecOTModalProps
> = ({ onClose, open, ordenTrabajo }) => {

  const queryClient = useQueryClient();
  const [showErrors, setShowErrors] = useState(false);
  const [reloadImages, setReloadImages] = useState(false);
  let TOTAL_FOTOS_SALIDA = 9;
  const PATH_BUCKET = `${BucketAwtENUM.IMAGE_INSTALACION}/${ordenTrabajo?.id_orden_trabajo}`;
  const TIPO_INTALACION_EXCLUDE_NORMAL = ordenTrabajo?.tipo_instalacion !=="NORMAL";
  const PUNTOS_RED_INSTALADOS = parseInt(ordenTrabajo?.puntos_red_instalados || "0");
  const PUNTOS_RED_NO_INSTALADOS = parseInt(ordenTrabajo?.puntos_red_no_instalados || "0");
  const ROUTER_ADICIONAL_INSTALADOS = (ordenTrabajo?.routers_adicionales_instalados || 0)*2;
  TOTAL_FOTOS_SALIDA = 9 + PUNTOS_RED_INSTALADOS + ROUTER_ADICIONAL_INSTALADOS + (TIPO_INTALACION_EXCLUDE_NORMAL ? 1 : 0);

  ///* global state ------------
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);
  const setAlert = useUiStore(s => s.setAlert);
  const setIsUploadingImgs = useUploadImageStore(s => s.setIsUploading);

  ///* custom hooks ------------
  const {
    UploadImageComponent,

    fotoTipoInstalacion, setFotoTipoInstalacion,
    fotoAdicional, setFotoAdicional,
    fotoPuntosRedInstalados, setFotoPuntosRedInstalados,
    fotoPuntosRedNoInstalados, setFotoPuntosRedNoInstalados,
    fotoRouterAdicionalInstalados, setFotoRouterAdicionalInstalados,

    fotoUbicacionONT,
    setFotoUbicacionONT,
    fotoReserva,
    setFotoReserva,
    fotoCroquisVirtual,
    setFotoCroquisVirtual,
    fotoTest2_4g,
    setFotoTest2_4g,
    fotoTest5g,
    setFotoTest5g,
    fotoPotenciaONT,
    setFotoPotenciaONT,
    fotoMaterialesContrato,
    setFotoMaterialesContrato,
    fotoPuntoInicial,
    setFotoPuntoInicial,
    fotoPuntoFinal,
    setFotoPuntoFinal,

  } = useUploadImageComponent();

  const { handleUploadFile } = useUploadFile();

  ///* mutations ------------
  const updateOT = useUpdateOrdenTrabajo<UploadSalidaImagesOTData & {estado_imagen_actualizacion?: string}>({
    enableRedirect: false,
    customSuccessMessage: 'Fotos de salida cargadas correctamente',
  });

  const fotosSalida = ordenTrabajo?.urls_fotos_salida?.photosSalida;
  const fotosCargadasSalida = ordenTrabajo?.urls_fotos_salida?.id_images_salida?.filter((id)=>id!==null)?.length || 0;
  const isEstadoFotosSalidaCompleto = (ids: any[]) => ids.filter((id)=>!!id).length >= TOTAL_FOTOS_SALIDA;

  const hasPhoto = (newPhoto: File | null, currentPhotoId?: string | null) => {
    return Boolean(newPhoto?.name || currentPhotoId);
  }

  const getMissingRequiredPhotos = () => {
    const missingPhotos: string[] = [];

    const requiredPhotos = [
      { label: 'Foto Ubicación ONT', isLoaded: hasPhoto(fotoUbicacionONT, fotosSalida?.fotoUbicacionONT?.photoId) },
      { label: 'Foto Reserva', isLoaded: hasPhoto(fotoReserva, fotosSalida?.fotoReserva?.photoId) },
      { label: 'Foto Croquis Virtual', isLoaded: hasPhoto(fotoCroquisVirtual, fotosSalida?.fotoCroquisVirtual?.photoId) },
      { label: 'Foto Test 2.4G', isLoaded: hasPhoto(fotoTest2_4g, fotosSalida?.fotoTest2_4g?.photoId) },
      { label: 'Foto Test 5G', isLoaded: hasPhoto(fotoTest5g, fotosSalida?.fotoTest5g?.photoId) },
      { label: 'Foto Potencia Interfaz ONT', isLoaded: hasPhoto(fotoPotenciaONT, fotosSalida?.fotoPotenciaONT?.photoId) },
      { label: 'Foto Hoja de Materiales', isLoaded: hasPhoto(fotoMaterialesContrato, fotosSalida?.fotoMaterialesContrato?.photoId) },
      { label: 'Foto Progresiva Inicial', isLoaded: hasPhoto(fotoPuntoInicial, fotosSalida?.fotoPuntoInicial?.photoId) },
      { label: 'Foto Progresiva Final', isLoaded: hasPhoto(fotoPuntoFinal, fotosSalida?.fotoPuntoFinal?.photoId) },
    ];

    if(TIPO_INTALACION_EXCLUDE_NORMAL){
      requiredPhotos.push({
        label: 'Foto Tipo Instalación',
        isLoaded: hasPhoto(fotoTipoInstalacion, fotosSalida?.fotoTipoInstalacion?.photoId),
      });
    }

    requiredPhotos.forEach((photo) => {
      if(!photo.isLoaded){
        missingPhotos.push(photo.label);
      }
    });

    for(let index = 0; index < PUNTOS_RED_INSTALADOS; index++){
      const key = `puntoRed${index + 1}`;
      if(!hasPhoto(fotoPuntosRedInstalados?.[index] || null, fotosSalida?.fotosAdicionales?.fotoPuntosRedInstalados?.[key]?.photoId)){
        missingPhotos.push(`Foto Punto de Red ${index + 1}`);
      }
    }

    for(let index = 0; index < PUNTOS_RED_NO_INSTALADOS; index++){
      const key = `puntoRedNoInstalado${index + 1}`;
      if(!hasPhoto(fotoPuntosRedNoInstalados?.[index] || null, fotosSalida?.fotosAdicionales?.fotoPuntosRedNoInstalados?.[key]?.photoId)){
        missingPhotos.push(`Foto Punto de Red No Instalado ${index + 1}`);
      }
    }

    for(let index = 0; index < ROUTER_ADICIONAL_INSTALADOS; index++){
      const key = `routerAdicional${index + 1}`;
      if(!hasPhoto(fotoRouterAdicionalInstalados?.[index] || null, fotosSalida?.fotosAdicionales?.fotoRoutersAdicionalesInstalados?.[key]?.photoId)){
        missingPhotos.push(`Foto Router Adicional ${index + 1}`);
      }
    }

    return missingPhotos;
  }

  ///* handlers ------------
  const handleUploadImages = async () => {

    // const estadoFotos = checkUploadedPhotos()
    const missingRequiredPhotos = getMissingRequiredPhotos();

    if(missingRequiredPhotos.length > 0){
      setShowErrors(true);
      setAlert(
        true,
        `Faltan cargar las siguientes fotos obligatorias: ${missingRequiredPhotos.join(', ')}`,
        AlertSeverityEnum.warning,
        7000
      );
      return;
    }

    let auxFotosSalida:PhotosSalidaOTType = ordenTrabajo?.urls_fotos_salida?.photosSalida || {}
    let imagesIds:any[] = []
    setIsGlobalLoading(true);
    setIsUploadingImgs(true);

    if(TIPO_INTALACION_EXCLUDE_NORMAL && fotoTipoInstalacion){
      const fotoTipoInstalacionRes = await handleUploadFile(fotoTipoInstalacion!,
        PATH_BUCKET)
      auxFotosSalida.fotoTipoInstalacion = {
        photoUrl: fotoTipoInstalacionRes?.url!,
        photoId: fotoTipoInstalacionRes?.id_archivos!,
        photoName: 'Foto Tipo Instalacion',
      }
      imagesIds.push(...extractIdsFromObjRes([fotoTipoInstalacionRes]))
    }else if(auxFotosSalida?.fotoTipoInstalacion){
      imagesIds.push(auxFotosSalida?.fotoTipoInstalacion?.photoId)
    }else{
      imagesIds.push(null)
    }
    if(fotoAdicional){
      const fotoAdicionalRes = await handleUploadFile(fotoAdicional!,
        PATH_BUCKET)
      auxFotosSalida.fotoAdicional = {
        photoUrl: fotoAdicionalRes?.url!,
        photoId: fotoAdicionalRes?.id_archivos!,
        photoName: 'Foto Adicional',
      }
      imagesIds.push(...extractIdsFromObjRes([fotoAdicionalRes]))
      TOTAL_FOTOS_SALIDA += 1;
    }

    if(PUNTOS_RED_INSTALADOS>0){
      const [
        ...fetchedPuntosRedInstalados
      ] = await Promise.all( fotoPuntosRedInstalados?.map((fotoPuntoRed: File|null)=>{
        if(fotoPuntoRed){
          return handleUploadFile(fotoPuntoRed, PATH_BUCKET)
        }
        return null
      }) || [])
      fetchedPuntosRedInstalados.forEach((fotoPuntoRed, index)=>{
        auxFotosSalida.fotosAdicionales ??= {};
        auxFotosSalida.fotosAdicionales.fotoPuntosRedInstalados ??= {};
        // console.log({fotoPuntoRed})
        if(fotoPuntoRed){
          auxFotosSalida.fotosAdicionales.fotoPuntosRedInstalados[`puntoRed${index+1}`] = {
            photoUrl: fotoPuntoRed?.url!,
            photoId: fotoPuntoRed?.id_archivos!,
            photoName: 'Foto Punto de Red '+(index+1),
          }
          imagesIds.push(...extractIdsFromObjRes([fotoPuntoRed]))
        }else{
          auxFotosSalida.fotosAdicionales.fotoPuntosRedInstalados[`puntoRed${index+1}`] = auxFotosSalida?.fotosAdicionales?.fotoPuntosRedInstalados?.[`puntoRed${index+1}`] || null
          imagesIds.push(auxFotosSalida?.fotosAdicionales?.fotoPuntosRedInstalados?.[`puntoRed${index+1}`]?.photoId)
        }
      })

    }

    if(PUNTOS_RED_NO_INSTALADOS>0){
      const [
        ...fetchedPuntosRedNoInstalados
      ] = await Promise.all( fotoPuntosRedNoInstalados?.map((fotoPuntoRedNoInstalado: File|null)=>{
        if(fotoPuntoRedNoInstalado){
          return handleUploadFile(fotoPuntoRedNoInstalado, PATH_BUCKET)
        }
        return null
      }) || [])
      fetchedPuntosRedNoInstalados.forEach((fotoPuntoRedNoInstalado, index)=>{
        auxFotosSalida.fotosAdicionales ??= {};
        auxFotosSalida.fotosAdicionales.fotoPuntosRedNoInstalados ??= {};
        // console.log({fotoPuntoRedNoInstalado})
        if(fotoPuntoRedNoInstalado){
          auxFotosSalida.fotosAdicionales.fotoPuntosRedNoInstalados[`puntoRedNoInstalado${index+1}`] = {
            photoUrl: fotoPuntoRedNoInstalado?.url!,
            photoId: fotoPuntoRedNoInstalado?.id_archivos!,
            photoName: 'Foto Punto de Red No Instalado '+(index+1),
          }
          imagesIds.push(...extractIdsFromObjRes([fotoPuntoRedNoInstalado]))
        }else{
          auxFotosSalida.fotosAdicionales.fotoPuntosRedNoInstalados[`puntoRedNoInstalado${index+1}`] = auxFotosSalida?.fotosAdicionales?.fotoPuntosRedNoInstalados?.[`puntoRedNoInstalado${index+1}`] || null
          imagesIds.push(auxFotosSalida?.fotosAdicionales?.fotoPuntosRedNoInstalados?.[`puntoRedNoInstalado${index+1}`]?.photoId)
        }
      })
    }

    if(ROUTER_ADICIONAL_INSTALADOS>0){
      const [
        ...fetchedRouterAdicionalInstalados
      ] = await Promise.all( fotoRouterAdicionalInstalados?.map((fotoRouterAdicional: File|null)=>{
        if(fotoRouterAdicional){
          return handleUploadFile(fotoRouterAdicional, PATH_BUCKET)
        }
        return null
      }) || [])
      fetchedRouterAdicionalInstalados.forEach((fotoRouterAdicional, index)=>{
        auxFotosSalida.fotosAdicionales ??= {};
        auxFotosSalida.fotosAdicionales.fotoRoutersAdicionalesInstalados ??= {};
        if(fotoRouterAdicional){
          auxFotosSalida.fotosAdicionales.fotoRoutersAdicionalesInstalados[`routerAdicional${index+1}`] = {
            photoUrl: fotoRouterAdicional?.url!,
            photoId: fotoRouterAdicional?.id_archivos!,
            photoName: 'Foto Router Adicional '+(index+1),
          }
          imagesIds.push(...extractIdsFromObjRes([fotoRouterAdicional]))
        }else{
          auxFotosSalida.fotosAdicionales.fotoRoutersAdicionalesInstalados[`routerAdicional${index+1}`] = auxFotosSalida?.fotosAdicionales?.fotoRoutersAdicionalesInstalados?.[`routerAdicional${index+1}`] || null
          imagesIds.push(auxFotosSalida?.fotosAdicionales?.fotoRoutersAdicionalesInstalados?.[`routerAdicional${index+1}`]?.photoId)
        }
      })
    }


    const arrayFotosSalida = [
      fotoUbicacionONT && fotoUbicacionONT?.name ? handleUploadFile(fotoUbicacionONT, PATH_BUCKET) : null,
      fotoReserva && fotoReserva?.name ? handleUploadFile(fotoReserva, PATH_BUCKET) : null,
      fotoCroquisVirtual && fotoCroquisVirtual?.name ? handleUploadFile(fotoCroquisVirtual, PATH_BUCKET) : null,
      fotoTest2_4g && fotoTest2_4g?.name ? handleUploadFile(fotoTest2_4g, PATH_BUCKET) : null,
      fotoTest5g && fotoTest5g?.name ? handleUploadFile(fotoTest5g, PATH_BUCKET) : null,
      fotoPotenciaONT && fotoPotenciaONT?.name ? handleUploadFile(fotoPotenciaONT, PATH_BUCKET) : null,
      fotoMaterialesContrato && fotoMaterialesContrato?.name ? handleUploadFile(fotoMaterialesContrato, PATH_BUCKET) : null,
      fotoPuntoInicial && fotoPuntoInicial?.name ? handleUploadFile(fotoPuntoInicial, PATH_BUCKET) : null,
      fotoPuntoFinal && fotoPuntoFinal?.name ? handleUploadFile(fotoPuntoFinal, PATH_BUCKET) : null,

    ]


    const [
      fotoUbicacionONTRes,
      fotoReservaRes,
      fotoCroquisVirtualRes,
      fotoTest2_4gRes,
      fotoTest5gRes,
      fotoPotenciaONTRes,
      fotoMaterialesContratoRes,
      fotoPuntoInicialRes,
      fotoPuntoFinalRes
    ] = await Promise.all(arrayFotosSalida);


    const filterArrayFotosSalida = [
      fotoUbicacionONTRes,
      fotoReservaRes,
      fotoCroquisVirtualRes,
      fotoTest2_4gRes,
      fotoTest5gRes,
      fotoPotenciaONTRes,
      fotoMaterialesContratoRes,
      fotoPuntoInicialRes,
      fotoPuntoFinalRes
    ].map((item, index) => {
        if(!!item){
          return item
        }else{
          switch (index) {
            case 0:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoUbicacionONT?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoUbicacionONT?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoUbicacionONT?.photoId,
              }
              : null
            case 1:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoReserva?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoReserva?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoReserva?.photoId,
              }
              : null
            case 2:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoCroquisVirtual?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoCroquisVirtual?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoCroquisVirtual?.photoId,
              }
              : null
            case 3:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoTest2_4g?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoTest2_4g?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoTest2_4g?.photoId,
              }
              : null
            case 4:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoTest5g?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoTest5g?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoTest5g?.photoId,
              }
              : null
            case 5:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPotenciaONT?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPotenciaONT?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPotenciaONT?.photoId,
              }
              : null
            case 6:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoMaterialesContrato?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoMaterialesContrato?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoMaterialesContrato?.photoId,
              }
              : null
            case 7:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPuntoInicial?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPuntoInicial?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPuntoInicial?.photoId,
              }
              : null
            case 8:
              return ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPuntoFinal?.photoId?
              {
                url: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPuntoFinal?.photoUrl,
                id_archivos: ordenTrabajo?.urls_fotos_salida?.photosSalida?.fotoPuntoFinal?.photoId,
              }
              : null
            default:
              return null
          }
      }
    })
    // console.log({filterArrayFotosSalida})

    const auxImagesIds = filterArrayFotosSalida.map((item) => {
      if(!!item){
        return extractIdsFromObjRes([item as ApiFileRespAWT])?.[0]
      }else{
        return null
      }
    })


    imagesIds = [ ...imagesIds, ...auxImagesIds];
    // console.log({imagesIds})

    auxFotosSalida = {
      ...auxFotosSalida,
      fotoUbicacionONT: {
        photoUrl: fotoUbicacionONTRes?.url || filterArrayFotosSalida[0]?.url || null,
        photoId: fotoUbicacionONTRes?.id_archivos || filterArrayFotosSalida[0]?.id_archivos || null,
        photoName: 'Foto Ubicación ONT',
      },
      fotoReserva: {
        photoUrl: fotoReservaRes?.url || filterArrayFotosSalida[1]?.url || null,
        photoId: fotoReservaRes?.id_archivos || filterArrayFotosSalida[1]?.id_archivos || null,
        photoName: 'Foto Reserva',
      },
      fotoCroquisVirtual: {
        photoUrl: fotoCroquisVirtualRes?.url || filterArrayFotosSalida[2]?.url || null,
        photoId: fotoCroquisVirtualRes?.id_archivos || filterArrayFotosSalida[2]?.id_archivos || null,
        photoName: 'Foto Croquis Virtual',
      },
      fotoTest2_4g: {
        photoUrl: fotoTest2_4gRes?.url || filterArrayFotosSalida[3]?.url || null,
        photoId: fotoTest2_4gRes?.id_archivos || filterArrayFotosSalida[3]?.id_archivos || null,
        photoName: 'Foto Test 2.4G',
      },
      fotoTest5g: {
        photoUrl: fotoTest5gRes?.url || filterArrayFotosSalida[4]?.url || null,
        photoId: fotoTest5gRes?.id_archivos || filterArrayFotosSalida[4]?.id_archivos || null,
        photoName: 'Foto Test 5G',
      },
      fotoPotenciaONT: {
        photoUrl: fotoPotenciaONTRes?.url || filterArrayFotosSalida[5]?.url || null,
        photoId: fotoPotenciaONTRes?.id_archivos || filterArrayFotosSalida[5]?.id_archivos || null,
        photoName: 'Foto Potencia ONT',
      },
      fotoMaterialesContrato: {
        photoUrl: fotoMaterialesContratoRes?.url || filterArrayFotosSalida[6]?.url || null,
        photoId: fotoMaterialesContratoRes?.id_archivos || filterArrayFotosSalida[6]?.id_archivos || null,
        photoName: 'Foto Materiales Contrato',
      },
      fotoPuntoInicial: {
        photoUrl: fotoPuntoInicialRes?.url || filterArrayFotosSalida[7]?.url || null,
        photoId: fotoPuntoInicialRes?.id_archivos || filterArrayFotosSalida[7]?.id_archivos || null,
        photoName: 'Foto Progresiva Inicial',
      },
      fotoPuntoFinal: {
        photoUrl: fotoPuntoFinalRes?.url || filterArrayFotosSalida[8]?.url || null,
        photoId: fotoPuntoFinalRes?.id_archivos || filterArrayFotosSalida[8]?.id_archivos || null,
        photoName: 'Foto Progresiva Final',
      },
    }


    onClose();

    updateOT.mutateAsync({
      id: ordenTrabajo?.id_orden_trabajo!,
      data: {
        estado_imagen_salida: isEstadoFotosSalidaCompleto(imagesIds) ?
        EstadosImagenChoiceEnum.UPD_REALIZADA
        : EstadosImagenChoiceEnum.UPD_SOLICITADA,
        estado_imagen_actualizacion: ordenTrabajo.estado_imagen_salida == EstadosImagenChoiceEnum.UPD_REALIZADA
                                    || ordenTrabajo.estado_imagen_salida == EstadosImagenChoiceEnum.CARGADO ?
                                      EstadosImagenChoiceEnum.UPD_REALIZADA : EstadosImagenChoiceEnum.UPD_SOLICITADA,
        urls_fotos_salida: {
          id_images_salida: imagesIds,
          photosSalida: auxFotosSalida,
        },
      },
    })

    await queryClient.invalidateQueries({
      queryKey: [OrdenTrabajoQueryKeysEnum.OrdenesTrabajo],
    });

    setIsGlobalLoading(false);
    setIsUploadingImgs(false);
  };



  useEffect(() => {
    if(showErrors){
      setTimeout(() => {
        setShowErrors(false)
      }, 5000);
    }
  }, [
    fotoUbicacionONT,
    fotoReserva,
    fotoCroquisVirtual,
    fotoTest2_4g,
    fotoTest5g,
    fotoPotenciaONT,
    fotoMaterialesContrato,
    fotoPuntoInicial,
    fotoPuntoFinal,
  ]);

  useEffect(()=>{
    const puntosRed = parseInt(ordenTrabajo?.puntos_red_instalados || "0");
    const routerAdicional = ((ordenTrabajo?.routers_adicionales_instalados) || 0) * 2;
    setFotoPuntosRedInstalados(new Array(puntosRed).fill(null));
    setFotoRouterAdicionalInstalados(new Array(routerAdicional).fill(null));
  },[])

  useEffect(() => {
    setTimeout(() => {
      setReloadImages(false)
    }, 1000);
  }, [reloadImages])

  return (
    <>
      <ScrollableDialogProps
        open={open}
        title="Actualización de Fotos Salida"
        minWidth="54%"
        minHeight="30vh"
        contentNode={
          <>
            <CustomPaperBox sxPaper={{ mb: 6 }}>
              <Grid item container spacing={3} justifyContent="center">
                {
                  ordenTrabajo?.observaciones?.observacion_foto_salida_upd_sol?
                    <CustomAlertCard
                      alertTitle="OBSERVACIONES"
                      alertContentNode={
                        <Typography variant="body1" textAlign="left">
                          {
                            ordenTrabajo?.observaciones?.observacion_foto_salida_upd_sol
                          }
                        </Typography>
                      }
                    />
                  :null
                }

                  <>
                  <Grid {...gridSizeMdLg12} container alignItems="center">
                    <Grid {...gridSizeMdLg6} container item justifyContent="left" p={2}>
                      <Typography variant="body1" fontWeight={700} textAlign="left">
                        Tiene {Math.min(fotosCargadasSalida, TOTAL_FOTOS_SALIDA)} de {TOTAL_FOTOS_SALIDA} fotos requeridas cargadas</Typography>
                    </Grid>
                    <Grid {...gridSizeMdLg6} container item justifyContent="right" p={2}>
                      <SingleIconButton
                        startIcon={<ReplayOutlined />}
                        color="info"
                        label={'Recargar Fotos Entrada'}
                        onClick={async () => {
                            setReloadImages(true)
                            await queryClient.invalidateQueries({
                              queryKey: [OrdenTrabajoQueryKeysEnum.OrdenesTrabajo],
                            });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <CustomPaperBox sxPaper={{ mb: 6 }}>
                    <Grid item container spacing={3} justifyContent="center">
                      <TabTextLabel text="Fotos de Salida" />

                      {
                        reloadImages?
                          <CircularProgress color="inherit" />
                        :
                        <>
                        <Grid item {...gridSizeMdLg6}>
                          <UploadImageComponent
                            buttonText={'Foto Ubicación ONT'}
                            selectedImage={fotoUbicacionONT}
                            setSelectedImage={setFotoUbicacionONT}
                            imageUrl={fotosSalida?.fotoUbicacionONT?.photoUrl||""}
                            idInput={'ubicacion-ont'} />
                          {showErrors && !fotoUbicacionONT?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Ubicación ONT es requerida</Typography>
                          :null}
                        </Grid>
                        <Grid item {...gridSizeMdLg6}>
                          <UploadImageComponent
                            buttonText={'Foto Reserva'}
                            selectedImage={fotoReserva}
                            setSelectedImage={setFotoReserva}
                            imageUrl={fotosSalida?.fotoReserva?.photoUrl||""}
                            idInput={'reserva'} />
                          {showErrors && !fotoReserva?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Reserva es requerida</Typography>
                          :null}
                        </Grid>
                        <Grid item {...gridSizeMdLg12}>
                          <UploadImageComponent
                            buttonText={'Foto Croquis Virtual'}
                            selectedImage={fotoCroquisVirtual}
                            setSelectedImage={setFotoCroquisVirtual}
                            imageUrl={fotosSalida?.fotoCroquisVirtual?.photoUrl||""}
                            idInput={'croquis-virtual'} />
                          {showErrors && !fotoCroquisVirtual?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Croquis Virtual es requerida</Typography>
                          :null}
                        </Grid>
                        <Grid item {...gridSizeMdLg6}>
                          <UploadImageComponent
                            buttonText={'Foto Test 2.4G'}
                            selectedImage={fotoTest2_4g}
                            setSelectedImage={setFotoTest2_4g}
                            imageUrl={fotosSalida?.fotoTest2_4g?.photoUrl||""}
                            idInput={'test-2-4g'} />
                          {showErrors && !fotoTest2_4g?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Test 2.4G es requerida</Typography>
                          :null}
                        </Grid>
                        <Grid item {...gridSizeMdLg6}>
                          <UploadImageComponent
                            buttonText={'Foto Test 5G'}
                            selectedImage={fotoTest5g}
                            setSelectedImage={setFotoTest5g}
                            imageUrl={fotosSalida?.fotoTest5g?.photoUrl||""}
                            idInput={'test-5g'} />
                          {showErrors && !fotoTest5g?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Test 5G es requerida</Typography>
                          :null}
                        </Grid>
                        <Grid item {...gridSizeMdLg6}>
                          <UploadImageComponent
                            buttonText={'Foto Potencia Interfaz ONT'}
                            selectedImage={fotoPotenciaONT}
                            setSelectedImage={setFotoPotenciaONT}
                            imageUrl={fotosSalida?.fotoPotenciaONT?.photoUrl||""}
                            idInput={'potencia-ont'} />
                          {showErrors && !fotoPotenciaONT?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Potencia Interfaz ONT es requerida</Typography>
                          :null}
                        </Grid>
                        <Grid item {...gridSizeMdLg6}>
                          <UploadImageComponent
                            buttonText={'Foto Hoja de Materiales'}
                            selectedImage={fotoMaterialesContrato}
                            setSelectedImage={setFotoMaterialesContrato}
                            imageUrl={fotosSalida?.fotoMaterialesContrato?.photoUrl||""}
                            idInput={'material-contrato'} />
                          {showErrors && !fotoMaterialesContrato?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Hoja de Materiales es requerida</Typography>
                          :null}
                        </Grid>
                        <Grid item {...gridSizeMdLg6}>
                          <UploadImageComponent
                            buttonText={'Progresiva Inicial'}
                            selectedImage={fotoPuntoInicial}
                            setSelectedImage={setFotoPuntoInicial}
                            imageUrl={fotosSalida?.fotoPuntoInicial?.photoUrl||""}
                            idInput={'punto-inicial'} />
                          {showErrors && !fotoPuntoInicial?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Progresiva Inicial es requerida</Typography>
                          :null}
                        </Grid>
                        <Grid item {...gridSizeMdLg6}>
                          <UploadImageComponent
                            buttonText={'Progresiva Final'}
                            selectedImage={fotoPuntoFinal}
                            setSelectedImage={setFotoPuntoFinal}
                            imageUrl={fotosSalida?.fotoPuntoFinal?.photoUrl||""}
                            idInput={'punto-final'} />
                          {showErrors && !fotoPuntoFinal?
                          <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>
                            La Foto Progresiva Final es requerida</Typography>
                          :null}
                        </Grid>
                        </>
                      }


                    </Grid>
                  </CustomPaperBox>




                  <CustomPaperBox sxPaper={{ mb: 6 }}>
                    <Grid item container spacing={3} justifyContent="center">
                      <TabTextLabel text="Fotos Adicionales" />
                      {reloadImages?
                          <CircularProgress color="inherit" />
                        :
                        <>
                          <Grid {...gridSizeMdLg12} item container spacing={3} justifyContent="center">
                            {
                              ordenTrabajo?.tipo_instalacion !=="NORMAL" && (
                              <Grid item {...gridSizeMdLg6}>
                                <UploadImageComponent
                                  buttonText={'Foto Tipo Instalación'}
                                  selectedImage={fotoTipoInstalacion}
                                  setSelectedImage={setFotoTipoInstalacion}
                                  idInput={'entrada-tipo-instalacion'}
                                  imageUrl={fotosSalida?.fotoTipoInstalacion?.photoUrl||""}
                                />
                                {showErrors && !fotoTipoInstalacion?
                                <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>La Foto Tipo Instalación es requerida</Typography>
                                :null}
                              </Grid>
                              )
                            }
                            <Grid item {...gridSizeMdLg6}>
                              <UploadImageComponent
                                buttonText={'Foto Adicional (Opcional)'}
                                selectedImage={fotoAdicional}
                                setSelectedImage={setFotoAdicional}
                                idInput={'entrada-adicional'}
                                imageUrl={fotosSalida?.fotoAdicional?.photoUrl||""}
                              />
                            </Grid>
                          </Grid>
                          <Grid {...gridSizeMdLg12} item container spacing={3} justifyContent="center">
                            {
                              parseInt(ordenTrabajo?.puntos_red_instalados || "0") > 0 && (<>
                                <TabTextLabel text="Fotos Puntos de Red Instalados" />
                                  {
                                    Array.from({ length: parseInt(ordenTrabajo?.puntos_red_instalados||"0") }, (_, i) => i).map((item)=>
                                    <Grid item {...gridSizeMdLg6}>
                                      <UploadImageComponent
                                        key={item+"_puntos-red"}
                                        buttonText={'Punto de Red '+(item+1)}
                                        selectedImage={fotoPuntosRedInstalados||null}
                                        setSelectedImage={setFotoPuntosRedInstalados}
                                        indexPhoto={item}
                                        idInput={'entrada-puntos-red-'+item}
                                        imageUrl={fotosSalida?.fotosAdicionales?.fotoPuntosRedInstalados?.[`puntoRed${item+1}`]?.photoUrl||""}
                                      />
                                      {showErrors && !fotoPuntosRedInstalados?.[item]?
                                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>{"La Foto Punto de Red "+(item+1)+" es requerida"}</Typography>
                                      :null}
                                    </Grid>
                                    )
                                  }
                              </>
                              )
                            }
                          </Grid>

                          <Grid {...gridSizeMdLg12} item container spacing={3} justifyContent="center">
                            {
                              parseInt(ordenTrabajo?.puntos_red_no_instalados || "0") > 0 && (<>
                                <TabTextLabel text="Fotos Puntos de Red No Instalados" />
                                  {
                                    Array.from({ length: parseInt(ordenTrabajo?.puntos_red_no_instalados||"0") }, (_, i) => i).map((item)=>
                                    <Grid item {...gridSizeMdLg6}>
                                      <UploadImageComponent
                                        key={item+"_puntos-red-no-instalados"}
                                        buttonText={'Punto de Red No Instalado '+(item+1)}
                                        selectedImage={fotoPuntosRedNoInstalados||null}
                                        setSelectedImage={setFotoPuntosRedNoInstalados}
                                        indexPhoto={item}
                                        idInput={'entrada-puntos-red-no-instalados-'+item}
                                        imageUrl={fotosSalida?.fotosAdicionales?.fotoPuntosRedNoInstalados?.[`puntoRedNoInstalado${item+1}`]?.photoUrl||""}
                                      />
                                      {showErrors && !fotoPuntosRedNoInstalados?.[item]?
                                      <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>{"La Foto Punto de Red No Instalado "+(item+1)+" es requerida"}</Typography>
                                      :null}
                                    </Grid>
                                    )
                                  }
                              </>
                              )
                            }
                          </Grid>

                          <Grid {...gridSizeMdLg12} item container spacing={3} justifyContent="center">
                            {
                              (ordenTrabajo?.routers_adicionales_instalados || 0) > 0 && (<>
                                <TabTextLabel text="Fotos Routers Adicionales Instalados" />
                                  {
                                    fotoRouterAdicionalInstalados?.map((_,index)=>
                                    <>
                                      <Grid item {...gridSizeMdLg6}>
                                        <UploadImageComponent
                                          key={index+"_routers-adicionales"}
                                          buttonText={`Router Adicional ${Math.floor(index / 2) + 1}${index % 2 === 0 ? 'A' : 'B'}`}
                                          selectedImage={fotoRouterAdicionalInstalados||null}
                                          setSelectedImage={setFotoRouterAdicionalInstalados}
                                          indexPhoto={index}
                                          idInput={'entrada-router-adicional-a-'+(index)}
                                          imageUrl={fotosSalida?.fotosAdicionales?.fotoRoutersAdicionalesInstalados?.[`routerAdicional${index+1}`]?.photoUrl||""}
                                        />
                                        {showErrors && !fotoRouterAdicionalInstalados?.[index]?
                                        <Typography variant="body1" fontWeight={700} color={"red"} textAlign={"center"}>{"La Foto Router Adicional "+(index+1)+" A es requerida"}</Typography>
                                        :null}
                                      </Grid>
                                    </>
                                    )
                                  }
                              </>
                              )
                            }
                          </Grid>
                        </>
                      }

                    </Grid>
                  </CustomPaperBox>
                </>

              </Grid>
            </CustomPaperBox>
          </>
        }
        onClose={onClose}
        onConfirm={handleUploadImages}
        confirmTextBtn="Guardar Fotos"
        confirmVariantBtn="outlined"
      />
    </>
  );
};

export default ActualizarFotosSalidaTecOTModal;
